require('../_lib/jwplayer/jwplayer');
global.jwplayer.key = 'NxEU9jRtdC0icra/Oe1HFf6xTcZE8aelKijr/j6qK1U=';
